import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";

import { getInvoiceDetails } from "../services/dataService";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { INVOICE_NUMBER_UPDATE } from "../columns/columns";
import BasicEditableTable from "./table/BasicEditableTable";
import { Invoiceupdatecolumn } from "./table/cell/Invoiceupdatecell";
import { toast } from "react-toastify";
import { dateBeforeMonths, today } from "../manager/dateManager";
import { GET_GENERATED_INVOICES } from "../store/ActionType";
import { dispatcher } from "../store/helper";
import {
  updateinvoicenumber,
  Sendmailinvoiceupdate,
} from "../services/dataService";

const Invoiceupdate = ({ InvoiceID, handleClose, Invoicedocid }) => {
  const [newinvoicenumber, setnewinvoicenumber] = useState("");
  const [isLoading, SetisLoading] = useState(false);
  const [fromDate, setFromDate] = useState(dateBeforeMonths(4));
  const [toDate, setToDate] = useState(today());
  const oldinvoicenumber = InvoiceID;

  const updateInvoiceData = (value) => {
    setnewinvoicenumber(value);
  };

  const refreshinvoicedetails = async () => {
    try {
      const response = await getInvoiceDetails({
        FromDate: fromDate,
        ToDate: toDate,
      });

      dispatcher(GET_GENERATED_INVOICES, response.data);
    } catch (e) {}
  };
  const onclick = async () => {
    const payload = { newinvoicenumber, Invoicedocid };
    const mailpayload = { Invoicedocid, oldinvoicenumber, newinvoicenumber };

    try {
      if (newinvoicenumber) {
        SetisLoading(true);
        await updateinvoicenumber(payload);
        await refreshinvoicedetails();
        toast.success("Invoice number updated");
        await Sendmailinvoiceupdate(mailpayload);
        toast.success("Email sent");
        handleClose();
        setnewinvoicenumber("");
        SetisLoading(false);
      } else {
        toast.error("Please enter invoice number");
      }
    } catch (error) {
      handleClose();
      SetisLoading(false);
      setnewinvoicenumber("");
      toast.error(error.response.data.Message || error.response.data.message);
    }
  };
  return (
    <Dialog
      open={Boolean(InvoiceID)}
      onClose={handleClose}
      sx={{
        position: "center",
        right: 8,
        top: 8,
      }}
    >
      <DialogTitle sx={{ ml: 0 }}>
        {"Update Invoice Number"}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          pt: "16px !important",
        }}
      >
        <Grid container spacing={2} pl={2}>
          <BasicEditableTable
            columns={INVOICE_NUMBER_UPDATE}
            data={[
              {
                Invoicenumber: `${InvoiceID}`,
                newinvoicenumber: "",
              },
            ]}
            defaultColumn={Invoiceupdatecolumn}
            updateLocalState={updateInvoiceData}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} sx={{ fontSize: "10px" }}>
          Close
        </Button>
        <Button
          variant="contained"
          onClick={onclick}
          sx={{ fontSize: "10px" }}
          disabled={isLoading}
        >
          {isLoading ? "submitting.." : "submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Invoiceupdate;
